// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1PQ38","header":"ClearentDisclaimer_header__2nuYn","inner":"ClearentDisclaimer_inner__2kOYB"};